export default "__VITE_ASSET__CtMmgg$C__"